import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // Replace these with your actual Firebase project config strings
  apiKey: "AIzaSyCD7udv06m7VSyto-0RoD3RCLzjtl9qKPA",
  authDomain: "dpdp-survey-4a15b.firebaseapp.com",
  projectId: "dpdp-survey-4a15b",
  storageBucket: "dpdp-survey-4a15b.firebasestorage.app",
  messagingSenderId: "326670130279",
  appId: "1:326670130279:web:a269d822be9d89203908c2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
